import type { IOrganization } from '@/types/organization'

export const ACME_ORGANIZATION_NAME = 'Acme Corporation'

const isAcmeOrganization = (organization: IOrganization): boolean => {
  return organization.name === ACME_ORGANIZATION_NAME
}

export default isAcmeOrganization
